import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgArrowLtr = (props: SvgProps) => (
  <Svg fill="none" height={24} width={24} {...props}>
    <Path
      d="M19.79 12.839a1 1 0 0 0 0-1.414L15.135 6.77a1 1 0 1 0-1.414 1.414l3.023 2.925H4.918a1 1 0 1 0 0 2H16.79l-3.07 2.97a1 1 0 1 0 1.414 1.415z"
      fill={props.color}
    />
  </Svg>
);
const Memo = memo(SvgArrowLtr);
export default Memo;
